import { Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Bell } from 'lucide-react';
import { api } from '@/api/client';
import { Icon } from '@/components/ui/Icon';
import { authClient } from '@/lib/auth-client';

/** How many messages are waiting; checked once a minute while the page is open. */
export function useUnreadCount(): number {
  const { data: session } = authClient.useSession();
  const list = useQuery({
    queryKey: ['notifications'],
    enabled: Boolean(session),
    refetchInterval: 60_000,
    queryFn: () => api.get('/api/v1/notifications'),
  });
  return list.data?.unreadCount ?? 0;
}

/** The bell: a link to the inbox with the number of unread messages on it. */
export function NotificationBell({ to }: { to: '/notifications' | '/admin/notifications' }) {
  const unread = useUnreadCount();
  return (
    <Link
      to={to}
      aria-label={unread > 0 ? `Notifications, ${unread} unread` : 'Notifications'}
      className="focus-ring relative grid size-11 place-items-center rounded-control text-ink"
    >
      <Icon icon={Bell} size={22} />
      {unread > 0 ? (
        <span className="absolute right-1.5 top-1.5 grid min-w-5 place-items-center rounded-full bg-danger px-1 text-[11px] font-bold leading-5 text-white">
          {unread > 9 ? '9+' : unread}
        </span>
      ) : null}
    </Link>
  );
}
